export default new Map([
    ['js', 'JavaScript'],
    ['ts', 'TypeScript'],
    ['tsx', 'TypeScript'],
    ['jsx', 'JavaScript'],
    ['json', 'JSON'],
    ['html', 'HTML'],
    ['css', 'CSS'],
    ['scss', 'SCSS'],
    ['md', 'Markdown'],
    ['yaml', 'YAML'],
    ['yml', 'YAML'],
    ['sh', 'Shell'],
    ['bash', 'Shell'],
    ['shell', 'Shell'],
    ['py', 'Python'],
    ['rb', 'Ruby'],
    ['java', 'Java'],
    ['kt', 'Kotlin'],
    ['ktm', 'Kotlin'],
    ['kts', 'Kotlin'],
    ['ktm', 'Kotlin'],
    ['go', 'Go'],
    ['rs', 'Rust'],
    ['php', 'PHP'],
    ['c', 'C'],
    ['cpp', 'C++'],
    ['cs', 'C#'],
    ['swift', 'Swift'],
    ['dart', 'Dart'],
    ['lua', 'Lua'],
    ['perl', 'Perl'],
    ['r', 'R'],
    ['sql', 'SQL'],
    ['scala', 'Scala'],
    ['groovy', 'Groovy'],
    ['tsql', 'T-SQL'],
    ['plsql', 'PL/SQL'],
]); 
